import React from 'react';
import { Query } from 'acast-reactor';
import Base from 'client/components/base';
import Divider from 'client/components/common/divider';
import DelayedInput from 'client/components/common/delayed-input';
import Loader from 'client/components/common/loader';
import Hero from 'client/components/landing/hero';
import LearnMore from 'client/components/landing/learn-more';
import GetApp from 'client/components/landing/get-app';
import Search from 'client/components/cc-modules/search-module';
import Grid from 'client/components/cc-modules/grid-landing-module';
import StringStore from 'client/stores/strings';

@Query.inject(props => {
  return {
    query: Query.run('GetCuratedContent', 'Landing'),
  };
})
export default class LandingView extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="view-landing">
        <Hero />
        <Divider />
        {this.modules}
        <LearnMore />
        <GetApp />
      </div>
    );
  }

  get modules() {
    let query = this.props.query;

    if (
      query.isComplete &&
      !query.error &&
      query.value &&
      query.value.modules
    ) {
      let data = query.value.modules;
      let result = [];

      data.forEach((module, key) => {
        switch (module.type.toLowerCase()) {
          case 'hero':
            result.push(<Hero key={key} module={module} />);
            break;

          case 'grid':
            result.push(<Grid key={key} module={module} />);
            break;

          case 'horizontallist':
            result.push(<HorizontalList key={key} module={module} />);
            break;

          case 'categories':
            result.push(<Categories key={key} module={module} />);
            break;

          case 'trending':
            result.push(<Trending key={key} module={module} />);
            break;

          case 'search':
            result.push(<Search key={key} module={module} />);
            break;

          default:
            console.log(
              `LandingView.get.modules: ${
                module.type
              } is an unsupported module type`
            );
        }
      });

      return result;
    } else if (query.error) {
      return <div style={{ display: 'none' }}>JSON.stringify(query.error)</div>;
    } else {
      let style = {};
      if (typeof window !== 'undefined') {
        style.height = `${window.innerHeight - 745}px`;
      }
      return <Loader style={style} />;
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/landing/view-landing.es6